
export const c_name = "COMPUTER INTITUTE APP"
export const c_phone = 9798288748
export const c_whatsapp = 9798288748
export const c_email = "cia@gmail.com"
export const c_address = "SAMASTIPUR, BIHAR (BR), India (IN), Pin Code:- 848101"
export const BASE_URL="https://computer-institute-app.netlify.app/"
export const c_shortName = "Computer Institute App"

